/**
 * buildInfo — Source unique des infos version/hash applicatives.
 *
 * Lit `process.env.REACT_APP_VERSION` et `process.env.REACT_APP_BUILD_HASH`
 * (injectés par `scripts/inject-build-info.js`, D94). Fallback `'dev'` si
 * vars absentes (cas CI sans hook npm pretest/prebuild).
 *
 * Consommé par <AppFooter /> (4 routes applicatives) et par les 4 pages
 * auth (LoginPage, SignupPage, ForgotPasswordPage, ResetPasswordPage)
 * pour uniformiser le wording marque + version + tooltip hash sur tous
 * les écrans utilisateurs (D100).
 *
 * Exports :
 *   - VERSION       : string brut (ex '10.5.145' ou 'dev')
 *   - BUILD_HASH    : string brut (ex 'd99776e' ou 'dev')
 *   - mainLine      : string composée 'EkynAir by Ekynea © 2026 · v{VERSION}'
 *   - tooltipTitle  : string composée 'Build {BUILD_HASH}'
 */
export const VERSION      = process.env.REACT_APP_VERSION    || 'dev';
export const BUILD_HASH   = process.env.REACT_APP_BUILD_HASH || 'dev';
export const mainLine     = `EkynAir by Ekynea © 2026 · v${VERSION}`;
export const tooltipTitle = `Build ${BUILD_HASH}`;
